/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 49,
  image: "default-changelog-v2.png",
  title: "New Storage SDK Version, New Browser-Upload SDK Version, Platform Improvements & Fixes",
  shortDescription: "We have published new versions of the Storage and Browser-Upload SDK's. We have also released a new version of the Spheron Platform with a couple of fixes and improvements.",
  description: "We have published new versions of the Storage and Browser-Upload SDK's. We have also released a new version of the Spheron Platform with a couple of fixes and improvements.",
  date: "Oct 23rd, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `

## [@spheron/spheron-storage:](https://www.npmjs.com/package/@spheron/storage) New Version v2.0.4

We have released a new version of the [@spheron/storage](https://www.npmjs.com/package/@spheron/storage) which includes a new function pinCIDs. This new function allows you to send an array of CIDs to be pinned on the Spheron IPFS Node. For more details check out the [DOCS](https://docs.spheron.network/sdk/storage-v2/#pin-cids-on-ipfs).

## [@spheron/browser-upload:](https://www.npmjs.com/package/@spheron/browser-upload) New Version v2.0.1

We have released a new version of the [@spheron/browser-upload](https://www.npmjs.com/package/@spheron/browser-upload) which includes a fix for the issue that the totalSize was not being increased for files larger than 5MB in the onChunkUploaded callback in the [upload function](https://docs.spheron.network/sdk/browser/#upload).

## Platform Improvements & Fixes

- **Dedicated Gateway Bandwidth Bonus:** Introducing support for the Dedicated Gateway Bandwidth bonus, offering enhanced options and flexibility in gateway resource management.
- **UI Support for CID Pinning:** Enhanced UI now allows easy pinning of a CID. Initiate new uploads and specify the CID to be pinned to the Spheron IPFS Node with greater simplicity.
- **User ID Accessibility in Settings:** For a smoother user experience, we've incorporated your user ID into the settings page. This allows for convenient access and copying, facilitating various interactions on our platform.
- **Commission Fee Integration:** The compute usage calculation now incorporates the commission fee set by the Spheron provider.
- **Removal of 5 AKT Mandatory Spending on Instance Deployment:** This requirement has been eliminated; Spheron now manages this aspect seamlessly.
- **Subscription Credit Deduction Fix for 'On-Demand' Instances:** On-demand instances have been updated with a refined mechanism for tracking subscription compute usage.
  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
